import { useCallback } from 'react'
import { useCaptureBrowserResource } from '~/features/browser-resources/browser-resource-boundary'
import { useProcess } from '~/store'
import {
  uploadDocument,
  uploadDocumentSelection,
  type UploadDocumentArgs,
  type UploadDocumentSelectionArgs
} from './index'

/** Captures opaque files at the React boundary and sends only replayable upload messages. */
export function useDocumentUploads() {
  const process = useProcess('documentUploads')
  const capture = useCaptureBrowserResource()
  const upload = useCallback(
    (args: UploadDocumentArgs) => process.send(uploadDocument(capture, args)),
    [capture, process]
  )
  const uploadSelection = useCallback(
    (args: UploadDocumentSelectionArgs) => process.send(uploadDocumentSelection(args)),
    [process]
  )

  return { ...process, upload, uploadSelection }
}
